module.exports = __webpack_public_path__ + "img/ruoyi7.3e39e1b5.png";